var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import EHandleStatus from '../../enum/EHandleStatus';
import GLOBAL_VUE from '../../globalVue';
import RequiredMixin from '../../components/renderHeader/RequiredMixin';
import ApplicationOrderService from '../../api/ApplicationOrderService';
import Header from './components/AddHeader.vue';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.order_id = '';
        _this.handleStatus = EHandleStatus.Add;
        _this.tableHeight = document.documentElement.clientHeight - 370;
        _this.formData = {
            type_id: '',
            order_ctime: '',
            business_id: '',
            depot_id: '',
            order_money: '',
            order_icomment: '',
            supplier_upper_id: '',
            fee_direction: '',
        };
        _this.data = [];
        _this.selections = [];
        return _this;
    }
    default_1.prototype.watchTypeId = function (newValue, oldValue) {
        if (this.handleStatus === 2)
            return;
        if (newValue)
            this.data = [];
    };
    default_1.prototype.created = function () {
        this.service = ApplicationOrderService.getInstance();
        if (this.order_id) {
            this.getDetail();
        }
    };
    default_1.prototype.deleteItem = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning('请选择费用');
            return;
        }
        this.$confirm('请确认是否删除该费用？', '提示').then(function (res) {
            _this.selections.forEach(function (item) {
                var index = _this.data.indexOf(item);
                _this.data.splice(index, 1);
            });
            if (_this.handleStatus === EHandleStatus.Edit) {
                window._czc.push(['_trackEvent', '修改费用', '删除费用', '删除费用']);
            }
            else {
                window._czc.push(['_trackEvent', '添加费用', '删除费用', '删除费用']);
            }
        }, function (err) { });
    };
    default_1.prototype.countOrderMoney = function () {
        var money = 0;
        this.data.map(function (item) {
            money = money + parseFloat(item.order_detail_money);
        });
        this.formData.order_money = Math.floor(money * 10000) / 10000;
    };
    default_1.prototype.changeGoodRow = function (row, type) {
        if (type === 'order_detail_amount' || type === 'order_detail_uprice') {
            if (row.order_detail_amount) {
                row.order_detail_amount = Math.abs(row.order_detail_amount);
            }
            if (row.order_detail_amount >= 0) {
                row.order_detail_money = Math.floor(row.order_detail_amount * row.order_detail_uprice * 10000) / 10000;
                this.countOrderMoney();
            }
        }
    };
    default_1.prototype.blurGoodRow = function (row, type) {
        if (type === 'order_detail_amount' && row.order_detail_amount) {
            row.order_detail_amount = Number(row.order_detail_amount);
        }
        if (type === 'order_detail_uprice' && row.order_detail_uprice) {
            row.order_detail_uprice = Number(row.order_detail_uprice);
        }
    };
    default_1.prototype.add = function () {
        var newProduct = {
            order_detail_name: '名称1',
            order_detail_spec: '',
            order_detail_amount: '',
            order_detail_uprice: '',
            order_detail_money: '',
            order_detail_icomment: '',
        };
        this.data.push(newProduct);
    };
    default_1.prototype.selectionChange = function (rows) {
        this.selections = rows;
    };
    default_1.prototype.save = function () {
        var _this = this;
        if (!this.checkSave())
            return;
        var params = __assign({}, this.formData, { data: this.data });
        if (this.order_id) {
            params = Object.assign({}, params, { order_id: this.order_id });
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service[this.order_id ? 'update' : 'create'](params)
            .then(function (res) {
            loadingInstance.close();
            _this.$message.success(res.data.msg || '保存成功');
            setTimeout(function () {
                GLOBAL_VUE.$emit('closeTab', _this);
                if (_this.opener)
                    _this.opener.getList();
            }, 500);
            if (_this.handleStatus === EHandleStatus.Edit) {
                window._czc.push(['_trackEvent', '修改费用', '保存', '保存']);
            }
            else {
                window._czc.push(['_trackEvent', '添加费用', '保存', '保存']);
            }
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    default_1.prototype.checkSave = function () {
        if (!this.formData.type_id) {
            this.$message.warning('费用类型不可为空');
            return false;
        }
        if (!this.formData.order_ctime) {
            this.$message.warning('发生时间不可为空');
            return false;
        }
        var flag = true;
        if (this.data && this.data.length) {
            this.data.map(function (row) {
                if (!row.order_detail_name || !row.order_detail_amount || !row.order_detail_uprice) {
                    console.log(row);
                    flag = false;
                }
            });
        }
        else {
            flag = false;
        }
        if (!flag) {
            this.$message.warning('费用明细、产品名称不可为空，数量大于0，单价大于0。');
            return false;
        }
        return true;
    };
    default_1.prototype.getDetail = function () {
        var _this = this;
        this.handleStatus = EHandleStatus.Edit;
        var params = {
            order_id: this.order_id,
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getDetail(params)
            .then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            _this.formData = Object.assign({}, _this.formData, {
                order_code: data.order_code,
                type_id: data.type_id,
                type_name: data.type_name,
                order_ctime: data.order_ctime,
                business_id: data.business_id || '',
                supplier_to_business_id: data.supplier_to_business_id || '',
                depot_id: data.depot_id || '',
                order_money: data.order_money,
                order_icomment: data.order_icomment,
                fee_direction: Number(data.fee_direction),
            });
            _this.data = Array.isArray(data.details) ? data.details : [];
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    __decorate([
        Watch('formData.type_id')
    ], default_1.prototype, "watchTypeId", null);
    default_1 = __decorate([
        Component({
            mixins: [RequiredMixin],
            components: {
                'add-header': Header,
            },
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
